// Auto-generado por @xone-web/staticweb (MPA Island mode).
// Config del proyecto baked at build time. NO EDITAR.

export const APP_CONFIG = {
    name: "Unnamed",
    title: "mRED_Web",
    version: "2026.10.30.02",
    tablePrefix: "gen",
    entryPoint: "Inicio",
    loginCollection: "LoginColl",
    autoLogon: false,
    backend: "webcore",
    filterParser: "simple",
    apiBase: "/api/itf",
    projectId: "CSUA6eGQmCNPofej3YOyqNRHN1gW1jWj",
    defaultLanguage: "javascript",
} as const;
